module.exports = __webpack_public_path__ + "static/media/loader.11ffc352.gif";